import { Button, Chip } from '@mui/material';
import { useRef } from 'react';
import { ListApiRef } from '../../components/data/ApiRef';
import DataTable, { ColumnData } from '../../components/data/DataTable';
import DataView from '../../components/data/DataView';
import { hasKey } from '../../models/Identity';
import Proxy from '../../models/Proxy';
import { Bill } from '../../models/Types';
import { isMobile, periodNumToText } from '../../utils';
import HouseCombo, { houseStore } from '../houses/HouseCombo';
import { BillForm, billParse } from './BillForm';
import BillList from './BillList';

export const columns: ColumnData<Bill>[] = [{
    label: 'Домовладение',
    name: 'HouseId',
    routerLink: true,
    store: houseStore,
    filter: (onChange) => <HouseCombo onChange={e => onChange(e.target.value)} allowAdd={false} />,
    renderer: (val, obj) => houseStore.data?.find(x => x.Id == val)?.Value
}, {
    name: "CreateDate",
    label: 'Дата',
    type: 'date'
}, {
    label: 'Период',
    name: 'PeriodNum',
    renderer: periodNumToText,
    filter: true,
    filterFn: (s, o) => (o.PeriodNum.toString().indexOf(s) >= 0) || (periodNumToText(o?.PeriodNum)?.indexOf(s) as number >= 0),
    width: 150
},  {
    label: 'Сумма',
    name: 'Amount',
    type: 'numeric',
    filter: true
}, {
    label: 'Статус',
    name: 'PaymentId',
    width: 10,
    renderer: x => <Chip size="small" color={x ? 'success' : 'error'} label={(x ? 'О' : 'Не о') + 'плачено'} />
}];

export const psBillCollumns = columns.filter(x => x.name !== 'PeriodNum').map(x => x.routerLink ? { ...x, routerLink: false } : x);

export default function BillView() {
    const listApi = useRef<ListApiRef<Bill>>();
    const periods = useRef<{
        CurPeriod: number
        PrevPeriod: number
    }>();
    const ism = isMobile();

    function recalculateAll() {
        if (periods.current) {
            Proxy.post('BillRecalcualteAll?period=' + periods.current.CurPeriod, false).then(x => {
                debugger;
                listApi.current?.load();
            });
        }
    }

    return <DataView<Bill>
        title="Начисление"
        titleMultiple="Начисления"
        typeId="Bill"
        modes={[{ mode: 'list', hideAddBtn: true }]}
        append={ism || !hasKey('Bill') ? null : () => <Button variant="outlined" onClick={recalculateAll}>Пересчитать текущий период</Button>}
        viewSx={{
            flexDirection: 'column'
        }}
        form={(id, apiRef) => <BillForm key="main" id={id} apiRef={apiRef} />}
        tableRenderer={p => ism ? <BillList {...p} /> : <DataTable<Bill> {...p} />}
        tableProps={{
            apiRef: x => listApi.current = x,
            columns,
            onAfterLoad: (d, x) => periods.current = { CurPeriod: x.result.CurPeriod, PrevPeriod: x.result.PrevPeriod },
            dataParser: billParse
        }} />;
}